import { render, staticRenderFns } from "./signatureDialog.vue?vue&type=template&id=59c10a69"
import script from "./signatureDialog.vue?vue&type=script&lang=js"
export * from "./signatureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports